<template>
  <q-page class="container" padding>
    <div class="row col-12 justify-between items-center">
      <div>
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          {{ "Relatórios Salvos" }}
        </p>
      </div>
      <q-btn
        href="https://sites.google.com/multpex.com.br/basedeconhecimento/d%C3%BAvidas-administrativas/relat%C3%B3rios-flexmonster"
        target="blank"
        icon="help"
        label="Clique aqui para acessar os modelos de relatorios"
        flat
        class="responsivo help q-mr-sm"
      >
      </q-btn>
    </div>
    <div class="row col-12 q-mt-lg q-mb-lg">
      <q-btn
        label="Selecionar Arquivo"
        icon="attach_file"
        color="blue"
        no-caps
        @click="abrirDialogoArquivo"
      />
    </div>
    <q-dialog v-model="excluir">
      <q-card style="width: 800px; max-width: 80vw">
        <div class="q-pl-sm text-h6">Deseja mesmo excluir esse relatorio?</div>

        <q-btn
          style="width: 100%"
          no-caps
          class="q-mt-sm"
          color="negative"
          label="Excluir Relatorio"
          @click="excluirRelatorio"
        />
      </q-card>
    </q-dialog>
    <div class="q-mt-md">
      <div class="row col-12 q-gutter-sm q-mb-sm text-brand-5 text-weight-bold">
        <div class="col-2">
          <div>Nome</div>
          <q-input debounce="500" v-model="filtrosTabela.nome" dense outlined />
        </div>
        <div class="col-2">
          <div>Tipo</div>
          <q-select
            input-debounce="500"
            v-model="filtrosTabela.tipoRelatorio"
            dense
            option-label="label"
            option-value="value"
            :options="listaTipoRelatorio"
            outlined
            @filter="filterFn"
            use-input
            behavior="menu"
          />
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        flat
        class="my-sticky-dynamic"
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        row-key="name"
        dense
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[1000]"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              <span>{{ col.label }}</span>
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              {{ props.row.nome }}
            </q-td>
            <q-td>
              {{ props.row.tipoRelatorio }}
            </q-td>
            <q-td>
              <div
                v-for="(filtro, index) in props.row?.filtrosTeste"
                :key="index"
              >
                <div
                  style="display: inline"
                  v-for="(chave, index2) in filtro"
                  :key="index2"
                >
                  {{ index2 == 0 ? `${chave}: ` : chave }}
                </div>
              </div>
            </q-td>
            <q-td class="btn-coluna">
              <q-btn
                round
                color="black"
                icon="download"
                class="q-ml-md"
                flat
                :disable="disable"
                @click="baixarModelo(props.row)"
              />
            </q-td>
            <q-td class="btn-coluna">
              <q-btn
                round
                color="blue-6"
                icon="info"
                flat
                :disable="disable"
                @click="carregarRelatorio(props.row)"
              />
            </q-td>
            <q-td class="btn-coluna">
              <q-btn
                round
                color="red"
                :disable="disable"
                icon="delete"
                flat
                @click="excluirRelatorio(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="rows.length > 14 || pagination.page > 1"
        class="row justify-center q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "nome",
    label: "Nome",
    field: "nome",
    align: "left",
  },
  {
    name: "tipoRelatorio",
    label: "Tipo",
    field: "relatorioTipo",
    align: "left",
  },
  {
    name: "filtros",
    label: "Filtros",
    align: "left",
  },
  {
    name: "baixarModelo",
    label: "Baixar Modelo",
    align: "left",
  },
  {
    name: "carregar",
    label: "Carregar",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];

import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

export default {
  setup() {
    const quasar = useQuasar();
    const store = useStore();
    const router = useRouter();
    const listaRelatorios = ref("");
    const excluir = ref(false);
    const excluirId = ref("");
    const rows = ref([]);
    const tipo = ref("");
    const file = ref(null);
    const carregarRelatorioArquivo = ref(false);
    const exibir = ref(false);
    const dados = ref({});
    const gerarCsv = ref(false);
    const loadingValue = ref(false);
    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const layout = ref("flat");
    const types = ref([]);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const disable = ref(false);
    const loading = ref(false);
    const showGrandTotals = ref("");
    const filtrosTabela = ref({
      nome: "",
      tipoRelatorio: "",
    });
    const options = ref({
      tipoRelatorio: [
        {
          label: "Consumo",
          value: "consumo",
        },
        {
          label: "Permissão de Trabalho",
          value: "permissaodetrabalho",
        },
        {
          label: "Master Data",
          value: "masterdata",
        },
        {
          label: "Contratos",
          value: "gestao-contratos-relatorio",
        },
        {
          label: "Contratos (Legado)",
          value: "contratos",
        },
        {
          label: "Custos",
          value: "custos",
        },
        {
          label: "Custos Consolidado",
          value: "custos-consolidado",
        },
        {
          label: "Necessidade Compra",
          value: "necessidadecompra",
        },
        {
          label: "Status Troca",
          value: "statustroca",
        },
        {
          label: "Produtos Em Aberto",
          value: "produtosemaberto",
        },
        {
          label: "Estoque",
          value: "estoque",
        },
        {
          label: "Estoque Lote",
          value: "estoquelote",
        },
        {
          label: "Consumo Lote",
          value: "consumolote",
        },
        {
          label: "Ferramentas",
          value: "ferramentas",
        },
        {
          label: "Liberação Fora do Prazo",
          value: "liberacaoforaprazo",
        },
        {
          label: "Transferência Ferramentas",
          value: "transferenciaferramentas",
        },
        {
          label: "Estoque Localização",
          value: "estoquelocalizacao",
        },
        {
          label: "Segurança Emocional",
          value: "segurancaemocional",
        },
        {
          label: "Empréstimo Ferramenta",
          value: "emprestimo-ferramenta",
        },
        {
          label: "Movimentação de Status",
          value: "movimentacao-status",
        },
        {
          label: "Regras de Trocas",
          value: "regras-trocas",
        },
        {
          label: "Movimentação de Estoque Manual",
          value: "movimentacao-manual",
        },
        {
          label: "Devolução de Materiais",
          value: "devolucao-materiais",
        },
        {
          label: "Estoque Consolidado",
          value: "estoque-consolidado",
        },
        {
          label: "Relatório MRP",
          value: "relatorio-mrp",
        },
        {
          label: "Transferência Estoque",
          value: "transferencia-estoque",
        },
        {
          label: "Entrada NF",
          value: "entrada-nf",
        },
        {
          label: "Retiradas sem Biometria",
          value: "retirada-sem-biometria",
        },
        {
          label: "Treinamento",
          value: "relatorio-treinamento",
        },
        {
          label: "Centro de Custo",
          value: "relatorio-centro-custo",
        },
        {
          label: "Fornecedores",
          value: "relatorio-fornecedores",
        },
        {
          label: "Grupo Produto",
          value: "relatorio-grupo-produto",
        },
        {
          label: "Notificação",
          value: "relatorio-notificacao",
        },
        {
          label: "Itens Não Codificados Compra",
          value: "relatorio-itens-nao-codificados-compra",
        },
        {
          label: "GHE",
          value: "relatorio-ghe",
        },
        {
          label: "Autenticações",
          value: "relatorio-autenticacoes",
        },
        {
          label: "Custos NF e Voucher",
          value: "relatorio-custos-nf-voucher",
        },
        {
          label: "Documentos",
          value: "relatorio-documentos",
        },
        {
          label: "Tipo Documento",
          value: "relatorio-tipo",
        },
        {
          label: "Categoria Documento",
          value: "relatorio-categoria-documento",
        },
        {
          label: "Documento Vinculado",
          value: "relatorio-documento-vinculado",
        },
        {
          label: "Relatório Catálogo",
          value: "ferramentaria-relatorio-catalogo",
        },
        {
          label: "Relatório Ativos",
          value: "ferramentaria-relatorio-ativos",
        },
        {
          label: "Relatório Ativos Simplificado",
          value: "ferramentaria-relatorio-ativos-simplificado",
        },
        {
          label: "Relatório Empréstimo",
          value: "ferramentaria-relatorio-emprestimo",
        },
        {
          label: "Relatório Movimentação",
          value: "ferramentaria-relatorio-movimentacao",
        },
        {
          label: "Relatório Cátalago Simplificado",
          value: "ferramentaria-relatorio-catalogo-simplificado",
        },
        {
          label: "Relatório Ativos Externos",
          value: "ferramentaria-relatorio-ativo-externo",
        },
        {
          label: "Relatório Respostas Acessórios/Checklists",
          value: "ferramentaria-relatorio-checklist-acessorio",
        },
        {
          label: "Relatório Integração Picking",
          value: "pkg-relatorio-integracao",
        },
        {
          label: "Relatório Controle de Tempo Picking",
          value: "pkg-controle-tempo",
        },
        {
          label: "Relatório PTs",
          value: "relatoriogeral-pt",
        },
        {
          label: "Relatório Atividades",
          value: "relatorioatividades-pt",
        },
        {
          label: "Relatório Participantes",
          value: "relatorioparticipantes-pt",
        },
      ],
    });
    const listaTipoRelatorio = ref([]);

    const getRelatoriosSalvos = async (page = 0, perPage = 15) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("rel/listarRelatoriosSalvos", {
          tipoRelatorio: filtrosTabela.value.tipoRelatorio?.value,
          nome: filtrosTabela.value.nome,
          page,
          perPage,
        });

        rows.value = response.data.resultado.dados;
        converterFiltros();
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
        store.commit("rel/ALTERAR_RELATORIO_SALVO", {
          estado: null,
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o tentar encontrar arquivos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        loading.value = false;
      }
    };

    const carregarRelatorio = async (relatorioSalvo) => {
      try {
        const template = JSON.parse(relatorioSalvo.template);
        
        const configuracoesRelatorio = {
          rotaNome: relatorioSalvo.tipoRelatorio,
          url: relatorioSalvo.url,
          id: relatorioSalvo.id,
          filtrosTela: "",
          layout: template?.layout,
          showTotals: template?.showTotals,
          showGrandTotals: template?.showGrandTotals,
          columns: template?.columns,
          rows: template?.rows,
          filtros: template?.filtros,
          template: template,
          values: template?.values,
        };

        store.commit("rel/SALVAR_RELATORIO", {
          relatorio: configuracoesRelatorio,
        });

        store.commit("rel/SET_AGUARDANDO_FILTROS", true);

        const mapeamentoRotas = {
          'contratos': 'gestao-contratos-relatorio',
          'vinculo': 'gestao-contratos-relatorio-vinculos',
          'relatoriovinculosrequisicao': 'gestao-contratos-relatorio-vinculos-requisicao'
        };

        const nomeDaRota = mapeamentoRotas[relatorioSalvo.tipoRelatorio] || relatorioSalvo.tipoRelatorio;

        router.push({
          name: nomeDaRota,
          params: { id: "carregado" },
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao carregar o relatório",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const excluirRelatorio = async (id) => {
      try {
        await store.dispatch("rel/exluirRelatorio", {
          id: id,
        });

        quasar.notify({
          message: "Relatório Excluido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getRelatoriosSalvos();
      } catch (error) {
        quasar.notify({
          message: "Erro a o excluir relatório",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const abrirDialogoArquivo = () => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.style.display = "none";
      fileInput.addEventListener("change", handleFileChange);
      document.body.appendChild(fileInput);
      fileInput.click();
    };

    const handleFileChange = (event) => {
      file.value = event.target.files[0];
      event.target.removeEventListener("change", handleFileChange);
      event.target.remove();
    };

    const lerJsonSelecionado = () => {
      if (file.value.type != "") {
        quasar.notify({
          message: "Selecione um arquivo valido.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let conteudo = "";
      let reader = new FileReader();

      reader.onload = async function (event) {
        conteudo = event.target.result;
        receberJson(conteudo);
      };
      reader.readAsText(file.value);
    };

    const receberJson = (json) => {
      dados.value = JSON.parse(json);
      file.value = null;

      store.commit("rel/SALVAR_RELATORIO", {
        relatorio: dados.value,
      });

      store.commit("rel/SET_AGUARDANDO_FILTROS", true);
      
      if (
        store.state.rel.relatorioCarregado == null ||
        store.state.rel.relatorioCarregado.rotaNome === undefined
      ) {
        quasar.notify({
          message: "Não foi possível abrir o arquivo selecionado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      const mapeamentoRotas = {
        'contratos': 'gestao-contratos-relatorio',
        'vinculo': 'gestao-contratos-relatorio-vinculos',
        'relatoriovinculosrequisicao': 'gestao-contratos-relatorio-vinculos-requisicao'
      };

      const rotaNome = mapeamentoRotas[store.state.rel.relatorioCarregado.rotaNome.toLowerCase()] 
        || store.state.rel.relatorioCarregado.rotaNome;

      router.push({
        name: rotaNome,
        params: { id: "carregado" },
      });
    };

    const gerarRelatorioArquivo = (response) => {
      const keys = Object.keys(response);

      const lastKey = keys[keys.length - 1];

      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.layout;
      showTotals.value = dados.value.showTotals;
      showGrandTotals.value = dados.value?.showGrandTotals;
      link.value = Object.values(response[lastKey])[0];

      slice.value.columns = dados.value.columns;
      slice.value.rows = dados.value.rows;
      slice.value.reportFilters = dados.value.filtros;
      slice.value.measures = dados.value.values;
      exibir.value = true;

      slice.value.rows.forEach((e) => {
        e.type = "number";
      });

      loadingValue.value = false;
      gerarCsv.value = false;
    };

    const baixarModelo = async (relatorio) => {
      relatorio.template = await JSON.parse(relatorio?.template);

      let configuracoesRelatorio = {
        rotaNome: relatorio.tipoRelatorio,
        url: relatorio.url,
        id: relatorio.id,
        filtrosTela: "",
        layout: relatorio?.template.layout,
        showTotals: relatorio?.template.showTotals,
        showGrandTotals: relatorio?.template.showGrandTotals,
        columns: relatorio.template?.columns,
        rows: relatorio.template?.rows,
        filtros: relatorio.template?.filtros,
        template: relatorio.template,
        values: relatorio.template?.values,
      };

      let json = JSON.stringify(configuracoesRelatorio, null, 2);

      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/json;charset=utf-8," + encodeURIComponent(json)
      );
      element.setAttribute("download", `relatorio-${relatorio.nome}`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
      loading.value = false;
    };

    const filtrarTipoRelatorio = (val) => {
      listaTipoRelatorio.value = options.value.tipoRelatorio.filter((value) => {
        return value.label
          .trim()
          .toLowerCase()
          .includes(val?.trim()?.toLowerCase());
      });
    };

    const converterFiltros = () => {
      rows.value.forEach((linha) => {
        try {
          if (!linha.filtros || linha.filtros.trim() === '') {
            linha.filtrosFormatados = {};
            linha.filtrosTeste = [];
            return;
          }
          
          linha.filtrosFormatados = JSON.parse(linha.filtros);
          linha.filtrosTeste = percorrerObjeto(linha.filtrosFormatados);
        } catch (error) {
          console.error(
            `Erro ao converter filtros da linha ${linha.nome}:`,
            error
          );
          linha.filtrosFormatados = {};
          linha.filtrosTeste = [];
        }
      });
    };

    const percorrerObjeto = (obj) => {
      const resultado = [];
      for (let chave in obj) {
        let valorTratado = formatarFiltros(obj[chave]);
        resultado.push([chave, valorTratado]);
      }
      return resultado;
    };

    const formatarFiltros = (valor) => {
      if (typeof valor === "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor)) {
        const [ano, mes, dia] = valor.split("-");
        return `${dia}/${mes}/${ano}`;
      } else if (Array.isArray(valor)) {
        let array = [];
        valor.forEach((value) => {
          if (value.label) {
            array.push(value.label);
          }
        });
        return array?.join(",");
      } else if (typeof valor === "object" && valor !== null) {
        return Object.entries(valor).map(([subChave, subValor]) => [
          subChave,
          formatarFiltros(subChave, subValor),
        ]);
      } else {
        return valor;
      }
    };

    watch(
      () => tipo.value,
      () => {
        getRelatoriosSalvos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        getRelatoriosSalvos(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      [() => filtrosTabela.value.tipoRelatorio, () => filtrosTabela.value.nome],
      () => {
        getRelatoriosSalvos();
      }
    );

    watch(
      () => file.value,
      () => {
        if (file.value == null) {
          return;
        }
        carregarRelatorioArquivo.value = true;
        lerJsonSelecionado();
      }
    );

    onMounted(getRelatoriosSalvos);
    return {
      getRelatoriosSalvos,
      tipo,
      tiposRelatorios: ["consumo"],
      listaRelatorios,
      carregarRelatorio,
      excluirRelatorio,
      excluir,
      columns,
      excluirId,
      rows,
      abrirDialogoArquivo,
      file,
      carregarRelatorioArquivo,
      exibir,
      filtrosTabela,
      lerJsonSelecionado,
      dados,
      gerarCsv,
      gerarRelatorioArquivo,
      loadingValue,
      formats,
      slice,
      filtrarTipoRelatorio,
      link,
      layout,
      types,
      showTotals,
      options,
      loading,
      filterFn(val, update) {
        filtrarTipoRelatorio(val);
        setTimeout(() => {
          update();
        }, 200);
      },
      disable,
      baixarModelo,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      showGrandTotals,
      listaTipoRelatorio,
      formatarFiltros,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 500px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr .coluna-btn {
  width: 120px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
